import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

import { ReactComponent as EventIcon } from "../../static/svg/old-event-icon.svg";
import PastEventsCarousel from "./PastEvent";
import UpcomingEvents from "./UpcomingEvents";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../../firebase";
import { useHistory } from "react-router-dom";
import AnimatedLoaderText from "../Common/Loading/AnimatedLoaderText";

export type ResourcesData = {
  caption: string;
  date: string;
  eventDate: string;
  eventType: string;
  releaseDate: string;
  imageList: string[];
  imgSrc: string;
  imgSrcMob: string;
  link: string;
  videoLink: string;
  registrationLink: string;
  url: string;
  slug: string;
  title: string;
  description: string;
  episodeNo: string;
  seasonNo: string;
  venue: string;
  length: string;
};

const EventGlance = () => {
  const [summitData, setSummitData] = useState<ResourcesData[]>([]); // ← fix
  const history = useHistory(); // ← add

  useEffect(() => {
    const fetchData = async () => {
      try {
        const collectionRef = collection(db, "caf-past-summit");
        const querySnapshot = await getDocs(
          query(
            collectionRef,
            orderBy("slug", "asc"),
          ),
        );

        const data = querySnapshot.docs
          .map((doc) => doc.data() as ResourcesData)
          .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

        setSummitData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  if (!summitData)
    return <AnimatedLoaderText text="Fetching data, please wait..." />;

  return (
    <React.Fragment>
      <Box px={{ xs: 4, sm: 10 }} py={{ xs: 2, sm: 4 }}>
        <Box>
          <EventIcon className="mx-auto" />
          <Box display="flex" justifyContent="center" py={3}>
            <Typography
              variant="caption"
              fontSize={{ xs: "11px", sm: "10px", md: "12px" }}
              lineHeight={{ xs: "80%", sm: "189%" }}
              letterSpacing={"0.1em"}
              className="text-center mx-auto"
            >
              Events
            </Typography>
          </Box>
          <Typography
            variant="h2"
            fontSize={{ xs: "30px", sm: "45px", md: "55px" }}
            lineHeight={{ xs: "103%", sm: "105.5%" }}
            letterSpacing={"-0.05em"}
            className="text-center mx-auto"
          >
            {/* 2025 At A Glance */}
            {/* Moments of Care */}
            Moments That Made Us
          </Typography>
        </Box>

        <PastEventsCarousel
          events={summitData.map((event) => ({
            date: event.date,
            title: event.title,
            body: event.caption,
            imageUrl: event.imageList[0],
            onHighlightsClick: () =>
              history.push(
                `/events/past/${event.slug}`,
                "_blank",
                // `/recap-summit/${event.date?.toString().slice(-4)}/${event.slug}`,
              ),
          }))}
        />

        <UpcomingEvents />
      </Box>
    </React.Fragment>
  );
};

export default EventGlance;
